import { FC } from 'react';
import { Link as RouterLink, useLocation } from 'react-router';
import {
  Tab,
  Tabs,
} from '@mui/material';

import { useRouter } from '@cvt/routing';

import { useMatchedRoute } from '@shared/hooks/useMatchedRoute';


export type Filters = keyof Meetings.GetListParams;

export const MeetingListTabs: FC = () => {
  const location = useLocation();
  const router = useRouter();


  const query = location.search;

  const tabIndex = useMatchedRoute([
    `${router.meetings.list.upcoming.path}`,
    `${router.meetings.list.past.path}`,
    `${router.meetings.list.all.path}`,
  ]);

  const activeTab = tabIndex === -1 ? 0 : tabIndex;

  return (
    <Tabs
      value={activeTab}
      variant="fullWidth"
      textColor="primary"
      sx={{
        height: { xs: 'auto', sm: undefined },
        p: { xs: 0.5, sm: 'initial' },
      }}
    >
      <Tab label="Upcoming Meetings" component={RouterLink} to={`${router.meetings.list.upcoming.path}${query}`} sx={{ p: { xs: 1, sm: undefined } }}/>
      <Tab label="Past Meetings" component={RouterLink} to={`${router.meetings.list.past.path}${query}`} sx={{ p: { xs: 1, sm: undefined } }}/>
      <Tab label="All Meetings" component={RouterLink} to={`${router.meetings.list.all.path}${query}`} sx={{ p: { xs: 1, sm: undefined } }}/>
    </Tabs>
  );
};
